<template>
  <div class="user">
    <div class="photo">
      <img src="static/img/default-avatar.png" alt="avatar" />
    </div>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click.stop="toggleMenu" href="#">
        <span>
          {{ fullName }}
          <b class="caret"></b>
        </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <el-collapse-transition>
          <ul class="nav user-nav-menu" v-show="!isClosed">
            <li>
              <router-link class="profile-dropdown" to="/logout">
                <i class="fa-solid fa-right-from-bracket"></i>
                <span class="sidebar-normal">{{$t('Sistemdən_çıxış')}}</span>
              </router-link>
            </li>
            <li class="lang-selector-container">
              <router-link class="profile-dropdowsn lang-link-style" v-for="lang in languages" :key="lang.code" to="#"
                @click.native.prevent="onLang(lang.code)"
                :class="{ 'selected-language': $store.state.lang === lang.code }">
                <span class="sidebar-normal">{{ lang.code }}</span>
              </router-link>
            </li>
          </ul>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>

<script>
  import CollapseTransition from "element-ui/lib/transitions/collapse-transition";

  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition,
    },
    props: {
      title: {
        type: String,
        default: "İstifadəçi adı",
      },
    },
    data() {
      return {
        isClosed: true,
        fullName: this.title,
        languages: [
          { code: 'AZ', name: 'Azərbaycan' },
          { code: 'EN', name: 'English' },
            { code: 'TR', name: 'Türkiye' },
          { code: 'RU', name: 'Russia' },
        ],
      };
    },
    methods: {
      toggleMenu(event) {
        if (event.target.closest('.user') || event.target.closest('.caret')) {
          this.isClosed = !this.isClosed;
        }
      },
      onLang(lg) {
        this.$store.dispatch("setLang", lg);
        location.reload();
      },
    },
    mounted() {
      this.fullName = this.$store.state.user.name;
    },
  };
</script>

<style>
  .collapsed {
    transition: opacity 1s;
  }

  .profile-dropdown:hover,
  .profile-dropdowsn:hover,
  .selected-language {
    color: #FFFFFF;
    opacity: 1;
    background: rgba(255, 255, 255, 0.23);
    border-radius: 4px;
  }

  .selected-language:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  .sidebar-mini .profile-dropdown:hover,
  .sidebar-mini .profile-dropdowsn:hover,
  .sidebar-mini .selected-language {
    background: transpareznt;
    color: inherit;
  }

  .user-nav-menu {
    padding-top: 10px;
    margin-left: 15px;
  }

  .lang-selector-container {
    display: flex;
    gap: 10px;
    padding: 5px 15px;
  }

  .lang-link-style {
    display: inline-block;
    padding: 5px 10px;
    margin: 0;
    font-size: var(--font-large);
  }
</style>